/**
 * Выбор варианта плана — общая шапка экранов варианта.
 *
 * Вариант плана ведётся ПО ХОЗЯЙСТВУ (ADR-045 D3: сценарий = хозяйство ×
 * сезон), поэтому хозяйство выбирается первым — иначе непонятно, чьи варианты
 * показывать. Сам выбор хозяйства жил здесь пилюлями, потом — штатным
 * контролом экрана (AK-745); теперь его на экране нет вовсе: AK-866 В-3,
 * область — из переключателя (AK-897). Здесь только варианты — их единицы,
 * и чипы для них уместны.
 *
 * Выбор живёт в адресе строки: ссылку на конкретный вариант («посмотри
 * базовый») кидают в переписке, и она обязана открывать его.
 */
import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';
import type { PlanVariant } from '@/lib/planning/techCards';
import { RenameVariantButton } from '../RenameVariantButton';

/**
 * Переименование живёт ЗДЕСЬ, а не на конкретном экране (требование founder
 * 21.08 пришло с посевного плана): переключатель вариантов один на четыре
 * экрана раздела, и класть карандаш только на один из них значило бы, что
 * «имя можно поменять» зависит от того, с какой страницы человек зашёл.
 *
 * Карандаш — только у АКТИВНОГО чипа: переименовать «тот вариант, что не
 * открыт» — действие вслепую, а ряд из N карандашей превращает переключатель
 * в панель управления. Он стоит отдельной кнопкой рядом с чипом, а не внутри
 * него: кнопка внутри кнопки — невалидная разметка, и клик по ней всё равно
 * переключал бы вариант.
 */
export function VariantTabs({
  variants,
  currentId,
  onSelect,
  actions,
}: {
  variants: PlanVariant[];
  currentId: string | null;
  onSelect: (id: string) => void;
  actions?: React.ReactNode;
}) {
  const current = variants.find((v) => v.id === currentId) ?? null;
  return (
    <div className="flex flex-wrap items-center gap-2">
      <span className="text-sm text-muted-foreground">Вариант плана:</span>
      {variants.map((variant) => (
        <Button
          key={variant.id}
          type="button"
          size="sm"
          variant={variant.id === currentId ? 'default' : 'outline'}
          onClick={() => onSelect(variant.id)}
        >
          {variant.name}
          {variant.is_selected && (
            <Badge variant="primary" className="ml-2">
              план сезона
            </Badge>
          )}
        </Button>
      ))}
      {current && (
        <RenameVariantButton
          variantId={current.id}
          currentName={current.name}
          existingNames={variants.map((v) => v.name)}
        />
      )}
      {actions}
    </div>
  );
}
